import { b2x } from '@b2x/react/src';

import { useAppContext } from './AppContext';
import { Container } from './Container';

export interface FooterProps {}

export const Footer = (props: FooterProps) => {
  const { hideFooter } = useAppContext();

  return (
    <>
      {!hideFooter && (
        <div className="bg-red py-3">
          <Container>
            <b2x.Row>
              <b2x.Col>
                <b2x.router.Link className="text-white" to="https://store.asroma.com/">
                  A.S. Roma Store
                </b2x.router.Link>
              </b2x.Col>
            </b2x.Row>
          </Container>
        </div>
      )}
    </>
  );
};
